export default __webpack_public_path__ + "static/media/apps-placeholder.adf7834d.jpg";